import './polyfills/global';
import theme from './theme/tokens';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

theme.applyTheme();

if (process.env.NODE_ENV === "development") {
  import("react-grab");
}

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

